// extracted by mini-css-extract-plugin
export default {"container":"services_container__SaimI","text":"services_text__NZZ0S","services":"services_services__Upa2Z","service":"services_service__b9dgc","active":"services_active__qzeNc"};